<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-6>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.push('/verified-research')"
      >
        <span>โครงการวิจัยที่ผ่านการพิจารณา</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>ระบุคณะอนุกรรมการ</span>
      </v-flex>
    </v-layout>

    <v-layout px-6 mt-12 class="text-start" style="background-color: #3E7662;">
      <v-flex my-2 style="color: #fff;font-weight: bold;font-size: 18px;">
        <span>ระบุคณะอนุกรรมการ</span>
      </v-flex>
    </v-layout>
    <v-card class="py-12">
      <v-layout v-if="isResubmission === '1'" px-6>
        <v-radio-group v-model="isHaveMeeting" row @change="onChangeRadio">
          <v-radio label="มีการประชุม" value="1" color="#3E7662"></v-radio>
          <v-radio label="ไม่มีการประชุม" value="0" color="#3E7662"></v-radio>
        </v-radio-group>
      </v-layout>
      <v-layout
        v-if="
            (considerType === '1' && oldVersionConsiderResult !== 'ปรับปรุงแก้ไขเพื่อรับรอง' && isResubmission === '0') ||
            (isResubmission === '1' && isHaveMeeting === '1')
        "
        mb-6
        style="padding-right: 100px;"
        class="text-start"
      >
        <v-flex xs3 mr-4 shrink d-flex align-center justify-end>
          <span>รอบการประชุม</span>
        </v-flex>
        <v-flex xs4 d-flex align-center justify-start>
          <v-select
            clearable
            placeholder="เลือกรอบการประชุม"
            v-model="form.joinMeeting"
            :menu-props="{ bottom: true, offsetY: true }"
            background-color="#3E7662"
            dark
            solo
            flat
            dense
            :items="joinMeetingList"
            item-text="name"
            item-value="id"
            hide-details
            @change="getSubcommittee"
          />
        </v-flex>
      </v-layout>

      <v-layout class="text-start">
        <v-flex mb-6 mx-6 style="font-weight: bold;">
          <!--<span v-if="considerType === '1'">เลือกคณะอนุกรรมาการ 3 ท่าน</span>-->
          <span
            >เลือกคณะอนุกรรมการ
            <span style="color: #CC3D45">*อย่างน้อย 1 ท่าน</span>
          </span>
        </v-flex>
      </v-layout>

      <!-- Select Row -->
      <v-layout mb-6 style="padding-right: 100px;" class="text-start">
        <v-flex xs3 mr-4 shrink d-flex align-center justify-end>
          <span>คณะอนุกรรมการ ที่ 1</span>
        </v-flex>
        <v-flex xs9 d-flex align-center justify-start>
          <!--          <v-select-->
          <!--            clearable-->
          <!--            placeholder="เลือกคณะอนุกรรมการ"-->
          <!--            v-model="form.subcommittee1"-->
          <!--            :menu-props="{ bottom: true, offsetY: true }"-->
          <!--            background-color="#3E7662"-->
          <!--            dark-->
          <!--            solo-->
          <!--            flat-->
          <!--            dense-->
          <!--            :items="subcommitteeList"-->
          <!--            item-text="name"-->
          <!--            item-value="id"-->
          <!--            hide-details-->
          <!--          />-->
          <v-autocomplete
            placeholder="เลือกคณะอนุกรรมการ"
            background-color="#FBF6F3"
            clearable
            :items="subcommitteeList"
            item-text="name"
            item-value="id"
            outlined
            dense
            color="#3E7662"
            hide-details
            v-model="form.subcommittee1"
          ></v-autocomplete>

          <!--                    @input="onSelect('1', $event)"-->
        </v-flex>
      </v-layout>

      <v-layout mb-6 style="padding-right: 100px;" class="text-start">
        <v-flex xs3 mr-4 shrink d-flex align-center justify-end>
          <span>คณะอนุกรรมการ ที่ 2</span>
        </v-flex>
        <v-flex xs9 d-flex align-center justify-start>
          <!--          <v-select-->
          <!--            clearable-->
          <!--            placeholder="เลือกคณะอนุกรรมการ"-->
          <!--            v-model="form.subcommittee2"-->
          <!--            :menu-props="{ bottom: true, offsetY: true }"-->
          <!--            background-color="#3E7662"-->
          <!--            dark-->
          <!--            solo-->
          <!--            flat-->
          <!--            dense-->
          <!--            :items="subcommitteeList"-->
          <!--            item-text="name"-->
          <!--            item-value="id"-->
          <!--            hide-details-->
          <!--          />-->
          <v-autocomplete
            placeholder="เลือกคณะอนุกรรมการ"
            background-color="#FBF6F3"
            clearable
            :items="subcommitteeList"
            item-text="name"
            item-value="id"
            outlined
            dense
            color="#3E7662"
            hide-details
            v-model="form.subcommittee2"
          ></v-autocomplete>
          <!--                    @input="onSelect('2', $event)"-->
        </v-flex>
      </v-layout>
      <v-layout mb-12 style="padding-right: 100px;" class="text-start">
        <v-flex xs3 mr-4 shrink d-flex align-center justify-end>
          <span>คณะอนุกรรมการ ที่ 3</span>
        </v-flex>
        <v-flex xs9 d-flex align-center justify-start>
          <!--          <v-select-->
          <!--            clearable-->
          <!--            placeholder="เลือกคณะอนุกรรมการ"-->
          <!--            v-model="form.subcommittee3"-->
          <!--            :menu-props="{ bottom: true, offsetY: true }"-->
          <!--            background-color="#3E7662"-->
          <!--            dark-->
          <!--            solo-->
          <!--            flat-->
          <!--            dense-->
          <!--            :items="subcommitteeList"-->
          <!--            item-text="name"-->
          <!--            item-value="id"-->
          <!--            hide-details-->
          <!--          />-->
          <v-autocomplete
            placeholder="เลือกคณะอนุกรรมการ"
            background-color="#FBF6F3"
            clearable
            :items="subcommitteeList"
            item-text="name"
            item-value="id"
            outlined
            dense
            color="#3E7662"
            hide-details
            v-model="form.subcommittee3"
          ></v-autocomplete>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-spacer></v-spacer>
        <v-flex mr-6 shrink d-flex align-center justify-end>
          <v-btn color="#fff"
            ><span
              style="color: #3E7662"
              @click="$router.push('/verified-research')"
              >ยกเลิก</span
            ></v-btn
          >
        </v-flex>
        <v-flex
          style="padding-right: 100px;"
          shrink
          d-flex
          align-center
          justify-end
        >
          <v-btn color="#3E7662" dark @click="save">บันทึก</v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../../components/table/FormTable";
import { mapState } from "vuex";
export default {
  components: {
    FormTable,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    form: {
      joinMeeting: "",
      subcommittee1: "",
      subcommittee2: "",
      subcommittee3: "",
    },
    joinMeetingList: [],
    subcommitteeList: [],
    subcommitteeList1: [],
    subcommitteeList2: [],
    considerType: "",
    oldVersionConsiderResult: "",
    isResubmission: '0',
    isHaveMeeting: '0'
  }),
  created() {
    this.considerType = this.$route.query.considerType;
    this.oldVersionConsiderResult = this.$route.query.oldVersionConsiderResult;
    this.isResubmission = this.$route.query.isResubmission
    this.getCurrentMeetingSelect();

    if (this.$route.query.considerType === "2" || this.isResubmission === '1') {
      this.showReviewerSelectAll();
    }
  },
  computed: {
    formJoinMeeting: function() {
      return this.form.joinMeeting;
    },
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  watch: {
    formJoinMeeting: function() {
      if (this.$route.query.considerType === "1") {
        this.getSubcommittee(this.form.joinMeeting);
      }
    },
  },
  methods: {
    onSelect(name, val) {
      if (name == "1") {
        this.subcommitteeList1 = this.subcommitteeList.filter(
          (item, i) => item.id !== val
        );
      }
      if (name == "2") {
        this.subcommitteeList2 = this.subcommitteeList1.filter(
          (item, i) => item.id !== val
        );
      }
    },
    onChangeRadio(){
      this.subcommitteeList = []
      this.subcommitteeList1 = []
      this.subcommitteeList2 = []
      if(this.isHaveMeeting === '0'){
        this.showReviewerSelectAll();
      }
    },
    getCurrentMeetingSelect() {
      this.isLoading = true;
      this.$store
        .dispatch("Meeting/getCurrentMeetingSelect")
        .then((res) => {
          res.forEach((data) => {
            this.joinMeetingList.push({
              id: data.id,
              name: "รอบที่ " + data.meetingNumber + " " + data.meetingDate,
            });
          });
          if (
            this.$route.query.considerType === "2" ||
            this.oldVersionConsiderResult === "ปรับปรุงแก้ไขเพื่อรับรอง"
          ) {
            this.showReviewerSelectAll();

            this.showChooseReviewer(this.$route.query.id);
          } else if (this.$route.query.considerType === "1") {
            this.getSubcommittee(this.form.joinMeeting);
            this.showChooseReviewer(this.$route.query.id);
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    getSubcommittee(id) {
      console.log("get sub committee", id);
      if (id) {
        console.log("in", id);
        this.subcommitteeList = [];
        this.isLoading = true;
        this.$store
          .dispatch("Research/showReviewerSelect", id)
          .then((res) => {
            res.forEach((data) => {
              data.forEach((item) => {
                this.subcommitteeList.push({
                  id: item.id,
                  name: item.thName,
                });
              });
            });
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
          });
      } else {
        this.subcommitteeList = [];
        this.form.subcommittee1 = "";
        this.form.subcommittee2 = "";
        this.form.subcommittee3 = "";
      }
    },
    showChooseReviewer() {
      // this.subcommitteeList = [];
      this.isLoading = true;
      this.$store
        .dispatch("Research/showChooseReviewer", this.$route.query.id)
        .then((res) => {
          console.log("Choose: ", res);
          if (
            this.$route.query.considerType === res[0].considerType.toString()
          ) {
            this.form.joinMeeting = res[0].meetingID;
            if (res.length > 0)
              res.forEach((data) => {
                this[`form`][`subcommittee${data.sequence}`] = data.userID;
              });
          }
          this.isLoading = false;
          // this.onSelect('1',  this.form.subcommittee1)
          // this.onSelect('2',  this.form.subcommittee2)
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    showReviewerSelectAll() {
      this.subcommitteeList = [];
      this.isLoading = true;
      this.$store
        .dispatch("Research/showReviewerSelectAll")
        .then((res) => {
          res.forEach((item) => {
            this.subcommitteeList.push({
              id: item.id,
              name: item.thName,
            });
          });
          this.isLoading = false;
          this.showChooseReviewer();
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    save() {
      let data = [];
      data["meetingID"] = this.form.joinMeeting;
      data["researchID"] = this.$route.query.id;
      data["considerType"] = this.$route.query.considerType;
      data["reviewerDatas"] = [
        this.form.subcommittee1 !== ""
          ? { userID: this.form.subcommittee1 }
          : {},
        this.form.subcommittee2 !== ""
          ? { userID: this.form.subcommittee2 }
          : {},
        this.form.subcommittee3 !== ""
          ? { userID: this.form.subcommittee3 }
          : {},
      ];
      this.isLoading = true;
      this.$store.dispatch("Research/saveChooseReviewer", data).then((res) => {
        Swal.fire({
          title: "บันทึกเรียบร้อยแล้ว",
          icon: "success",
          position: "center",
          confirmButtonColor: "#3E7662",
          confirmButtonText: "ตกลง",
        }).then(() => {
          this.$router.push("/verified-research");
        });
        this.isLoading = false;
      });
    },
  },
};
</script>

<style lang="scss">
.header-data-table {
  font-size: 20px;
}
.v-sheet {
  border-radius: 0 !important;
}
</style>
